import { getComponentFromName } from '../../lib/utils';

import { useGame } from '../../contexts/GameContext';
import { useTheme } from '../../contexts/ThemeContext';
import * as Components from './questionsResults';
import DefaultComponent from './questionsResults/DefaultQuestionResult';

interface QuestionResultProps {
    component?: string | null;
    [key: string]: any;
}

function QuestionResult({ component, ...props }: QuestionResultProps) {
    const { name, variant = null } = useTheme();
    const { theme } = useGame() || {};
    const { name: gameTheme = null } = theme || {};
    const Component =
        getComponentFromName(Components, component, null) ||
        getComponentFromName(Components, gameTheme, null) ||
        (variant || []).reduce(
            (acc, v) => acc || getComponentFromName(Components, v, null),
            null,
        ) ||
        getComponentFromName(Components, name, DefaultComponent) ||
        null;
    return Component !== null ? <Component {...props} /> : null;
}

export default QuestionResult;
